module.exports = __webpack_public_path__ + "static/media/imagem-mobile.8a0db84f.svg";